import { EditOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../Components/Button'
import TableBox from '../../../Components/TableBox/TableBox'
import FilterLayout from '../../../Layout/FilterLayout'
import TableLayout from '../../../Layout/TableLayout'
import apiClient from '../../../Util/apiClient'
import { GET_DATA, SET_DATA, validateAccess } from '../../../Util/Util'
import WarehouseFilter from './WarehouseFilter'

export default function Warehouses() {
  const [warehouses, setWarehouses] = useState([])
  const history = useHistory()

  const getData = (params) => {
    const filterCache = GET_DATA('warehouses.filterData') || {}
    params = { ...filterCache, ...params }

    apiClient.get('warehouses', { params }).then(({ status, data }) => {
      if (status === 200) {
        SET_DATA('warehouses.filterData', { ...params, ...data.pageData })
        setWarehouses(data.result)
      }
    })
  }

  useEffect(() => {
    getData()
  }, [])

  const columns = [
    {
      title: 'WH',
      dataIndex: 'warehouse'
    },
    {
      title: 'Warehouse Desc',
      dataIndex: 'description'
    },
    {
      title: 'Storage Loc.',
      dataIndex: 'location'
    },
    {
      title: 'Storage Loc Desc',
      dataIndex: 'locationDescription'
    },
    {
      title: 'Rack',
      dataIndex: 'rack'
    },
    {
      title: 'Rack Desc',
      dataIndex: 'rackDescription'
    },
    {
      ...(validateAccess('edit-warehouse') && {
        title: 'Action',
        dataIndex: 'custom_action',
        render: (text, row) => (
          <div className="btn-group">
            <Button onClick={() => history.push(`/app/edit-warehouse/${row.id}`)} className="btn-glow">
              <EditOutlined />
            </Button>
          </div>
        )
      })
    }
  ]

  return (
    <FilterLayout
      addButton={{
        title: 'Warehouse',
        onClick: () => history.push('/app/add-warehouse'),
        access: 'add-warehouse'
      }}
      filterData={GET_DATA('warehouses.filterData')}
      filter={<WarehouseFilter onSubmit={getData} />}>
      <TableLayout title="Warehouse Overview" exportUrl="warehouses/export">
        <TableBox
          dataSource={warehouses}
          columns={columns}
          pageData={GET_DATA('warehouses.filterData')}
          onChangePage={getData}
        />
      </TableLayout>
    </FilterLayout>
  )
}
